import { useEffect, useState } from 'react';
import config from '../../common/config';
import './styles/Digest2.less';

const Digest = ({ seq, play = false, onDataLoaded }: any) => {
  const [delayPlay, setDelayPlay] = useState(false);
  const slide = config.slides[seq];

  useEffect(() => {
    if (play) {
      setTimeout(() => {
        setDelayPlay(true);
      }, 300);
    } else {
      setDelayPlay(false);
    }
  }, [play]);

  return (
    <div className={`digest-wrapper digest-wrapper-${seq}`}>
      <div className="digest">
        <div className={`logo-q`}>
          <img src={(slide.images as Array<string>)[0]} alt="logo quality" />
        </div>

        <div className="text-block">
          <div className={`titles ani-fade-in'}`}>
            <div className="title title-primary">设计品质</div>
            <div className="title title-secondary">美学依据</div>
          </div>
          <div className={`description ${delayPlay ? 'ani-fade-in' : ''}`}>
            <div>基于成熟的美学结构，兼容不同的业务形态，</div>
            <div>保留适量的留白，提升阅读的舒适度。</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Digest;
